import React, { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { CheckIcon, Close, MoreIcon, PlayIcon, SuccessIcon } from 'src/icons/icons'
import ClickAwayListener from 'react-click-away-listener';
import { ExtendVisa } from 'src/components/visaActions/ExtendVisa';
import { CancelVisas } from 'src/components/visaActions/CancelVisas';
import { CrewListItem } from 'src/types';
import { useMutation } from 'react-query';
import { Post } from 'src/apis/api';
import Loading from 'src/components/Loading';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { toast } from 'react-toastify';

const ActionButton = ({ icon: Icon, title, color }: { icon: typeof MoreIcon, title: string, color?: string }) => <div className='flex text-right flex-row items-center  gap-2 cursor-pointer'>
    <Icon className='size-5' color={color} />
    <span className='text-right'>{title}</span>
</div>

export const TransactionOperation = ({ id, onSuccessMutate }: { id: number, onSuccessMutate: Function }) => {

    const [mode, setMode] = useState<'APPOROVE' | 'REJECT' | undefined>(undefined)

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState<boolean>(false)

    const { mutate, isLoading } = useMutation<any, { data: { message: string, msg: string } }, { status: number }>({
        mutationFn: ({ status }) => Post(`admin/transactions/settlement/update/${id}`,
            {
                form: "update_pay",
                status
            }
        ),

        onSuccess: (res: any) => {
            setMode(undefined)
            toast.success(res.msg);
            onSuccessMutate()

        },
        onError: (error) => {
            toast.error(error?.data?.message || error?.data?.msg);
        },
    })

    return (
        <div className='relative text-center ' >

            {/* {isLoading ? <Loading /> : <MoreIcon className='cursor-pointer size-6 text-black' onClick={() => setIsOpen(true)} />} */}

            <div className='flex flex-row items-center gap-2  justify-center rounded-lg  whitespace-nowrap text-sm'>

                <button
                    onClick={() => setMode('APPOROVE')}
                    className='bg-green-200 text-white duration-200 p-2 rounded-lg flex flex-row gap-1 items-center text-sm min-w-12 font-bold justify-center'
                    title={t('confirmShort')}

                >
                    <CheckIcon className='size-4' />
                    {t('confirmShort')}
                </button>


                <button
                    className='bg-red text-rose-100 p-2 rounded-lg  min-w-12 text-sm font-bold gap-1 flex flex-row items-center justify-center'
                    title={t('rejectShort')}
                    onClick={() => setMode('REJECT')}
                >
                    <Close color='red' />
                    {t('rejectShort')}
                </button>


            </div>
            {!!mode && createPortal(<div className={clsx('fixed top-0 left-0 h-full w-full backdrop-brightness-50 z-40 flex flex-row justify-center items-center', !mode ? 'opacity-0' : ' opacity-100')}>
                <div className={clsx('flex flex-col items-center gap-6 transition-all duration-300 bg-white max-w-[80vw] lg:max-w-[450px] rounded-2xl border p-4 relative max-h-[90vh] overflow-auto', !mode ? 'translate-y-full' : 'translate-y-0')}>


                    {mode == 'APPOROVE' && <SuccessIcon />}

                    {mode == 'REJECT' && <Close color='red' />}

                    <div className='absolute left-4 top-4 cursor-pointer' onClick={() => setMode(undefined)}> <Close color='gray' /></div>

                    <span>{mode == 'REJECT' ? t('AreYouSureToRejectTransaction') : t('AreYouSureToApproveTransaction')}</span>



                    <div className={clsx('flex flex-row gap-2 items-stretch whitespace-nowrap w-full', (isLoading) && 'grayscale cursor-not-allowed')}>
                        <button disabled={isLoading} className='px-5 flex-1 flex flex-row  justify-center items-center  py-2 text-center rounded-lg bg-primary-300 text-white ' onClick={() => mutate({ status: mode == 'REJECT' ? 2 : 1 })}>{isLoading ? <Loading /> : t('Yes')}</button>
                        <button disabled={isLoading} className='px-5 flex-1  py-2 text-center rounded-lg text-red flex flex-row  justify-center items-center ' onClick={() => setMode(undefined)}>{t('No')}</button>
                    </div>
                </div>
            </div>
                , document.body)}
        </div>
    )
}
